@if (explorer.result(); as items) {
  @if ((items.length > 0 || strategy.loading())) {
    <div class="flex flex-col sm:flex-col-reverse">
      <div class="flex flex-col max-h-[70vh] overflow-y-auto">
        <soft-master-detail class="h-[70vh]"
          [data]="items"
          [masterTemplate]="masterTemplate"
          [detailTemplate]="detailTemplate"
          [detailPlaceholder]="detailPlaceholder"
          (masterDblClick)="strategy.resolve($event)"
          #masterDetail>
        </soft-master-detail>
        <ng-template let-data='data' #masterTemplate>
          <div class="mx-2">
            <ng-container *ngComponentOutlet="config.masterComponent; inputs: {item: data}"></ng-container>
          </div>
        </ng-template>
        <ng-template let-data='data'  #detailTemplate>
          <div class="sm:hidden soft-link my-2">
            <a (click)="masterDetail.select(-1)">
              <div class="flex flex-row flex-nowrap items-center content-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
                Zurück
              </div>
            </a>
          </div>
          <div class="h-[65vh] overflow-y-auto m-2">
            <ng-container *ngComponentOutlet="config.detailComponent; inputs: {item: data}"></ng-container>
          </div>
          <button class="soft-button sticky bottom-0 accent w-full h-16 mt-2" (click)="strategy.resolve(data)">Auswählen</button>
        </ng-template>
        <ng-template #detailPlaceholder>
          <div class="w-full flex flex-col items-center mt-16 text-light">
            Noch nichts ausgewählt
          </div>
        </ng-template>
      </div>
      <soft-filter-and-sort class="block mx-2 mt-2 mb-2 sm:mb-0"
        [explorer]="explorer"
        [filterConfig]="config.filter"
        [sortConfig]="config.sort">
      </soft-filter-and-sort>
    </div>
  } @else {
    @if (!strategy.loading()) {
      <div
        class="flex flex-col text-light text-lg items-center content-center my-4">
        <span>Es wurden keine Daten gefunden</span>
      </div>
    }
  }
} @else {
  @if (!strategy.loading()) {
    <div
      class="flex flex-col text-light text-lg items-center content-center my-4">
      <span>Es wurden keine Daten gefunden</span>
    </div>
  }
}
